import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import { create as createModal, useModal } from "@ebay/nice-modal-react";
import { UnexpectedErrorContent } from "components/errors/components/unexpected-error-content";
import type { FetchClientError } from "errors/fetch-client-error";
import type { FetchServerError } from "errors/fetch-server-error";
import type { AppError } from "errors/index";

type ErrorModalProps = {
  error: Error | AppError | FetchServerError | FetchClientError;
};

export const ErrorModal = createModal<ErrorModalProps>(({ error }) => {
  const modal = useModal();

  return (
    <Modal
      isOpen={modal.visible}
      onClose={modal.hide}
      onCloseComplete={modal.remove}
    >
      <ModalOverlay />
      <ModalContent w={600}>
        <ModalHeader>Error</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <UnexpectedErrorContent error={error as Error} />
        </ModalBody>
        <ModalFooter>
          <Button onClick={modal.hide}>Close</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
});
